import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";

// images
import LOGO_MTN2 from "./../../assets/images/mtn-logo.svg";
import {
  getAbonneInfo_allRight,
  getAbonneOTPCode,
  resetAbonnePassword,
  verifieOTPCode,
} from "../../services/abonne/AbonneRequest";
import { isAuthenticated } from "../../utils/AuthGuard";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetchOTP, setFetchOTP] = useState(false);
  const [showCodeOtop, setShowCodeOtp] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [numero, setNumero] = useState("");
  const [codeOtp, setCodeOtp] = useState("");
  const [user, setUser] = useState(null);

  const getCodeOPT = () => {
    setLoading(true);
    setErrorMessage("");
    const customerNumber = sessionStorage.getItem("customer_number")
      ? sessionStorage.getItem("customer_number")
      : "";

    getAbonneOTPCode({
      numero: customerNumber
    })
      .then((res) => {
        setLoading(false);
        setShowCodeOtp(true);
      })
      .catch((err) => {
        setLoading(false);
        setShowCodeOtp(false);
        console.log(err);
        if (err.response) {
          setErrorMessage(err.response.data.donnee);
        } else {
          setErrorMessage("Une erreur s'est produite, essayer plus tard");
        }
      });

    // if (numero && numero.length === 10) {
    //   const data = {
    //     numero: numero,
    //   };
    // } else {
    //   setLoading(false);
    //   setErrorMessage("Entrer un numéro de téléphone à 10 chiffres");
    // }
  };

  const verificationDuCodeOTP = () => {
    setFetchOTP(true);
    setLoading(true);
    setErrorMessage("");
    const customerNumber = sessionStorage.getItem("customer_number")
      ? sessionStorage.getItem("customer_number")
      : "";

    if (codeOtp && codeOtp.length === 4) {
      const data = {
        numero: customerNumber,
        code: codeOtp,
      };

      verifieOTPCode(data)
        .then((res) => {
          setLoading(false);
          setFetchOTP(false);
          setErrorMessage("");
          sessionStorage.setItem("id", codeOtp);
          // sessionStorage.setItem("phoneNumber", numero);
          navigate("/reset-password");
        })
        .catch((err) => {
          setLoading(false);
          setFetchOTP(false);
          console.log(err);
          if (err.response) {
            setErrorMessage(err.response.data.donnee);
          } else {
            setErrorMessage("Une erreur s'est produite, essayer plus tard");
          }
        });
    } else {
      setFetchOTP(false);
      setLoading(false);
      setErrorMessage("Le code reçu par sms doit contenir 4 chiffres");
    }
  };

  const resendOTP = () => {};

  useEffect(() => {
    sessionStorage.removeItem("id");
    const customerNumber = sessionStorage.getItem("customer_number")
      ? sessionStorage.getItem("customer_number")
      : "";
    getAbonneInfo_allRight(customerNumber)
      .then((res) => {
        setUser(res.data.donnee);
        sessionStorage.setItem("user", JSON.stringify(res.data.donnee));
        if (
          isAuthenticated() &&
          res.data.donnee.motdepasseisactif &&
          sessionStorage.getItem("token")
        ) {
          navigate("/forfaits/acheter");
        } else if (
          !res.data.donnee.motdepasseisactif &&
          !sessionStorage.getItem("token")
        ) {
          navigate("/forfaits/acheter");
        }
      })
      .catch((err) => {
        console.log("api error", err);
      });

    if (
      isAuthenticated() &&
      user &&
      user.motdepasseisactif &&
      sessionStorage.getItem("token")
    ) {
      navigate("/forfaits/acheter");
    } else if (
      isAuthenticated() &&
      user &&
      !user.motdepasseisactif &&
      sessionStorage.getItem("token")
    ) {
      navigate("/forfaits/acheter");
    } else if (
      user &&
      !user.motdepasseisactif &&
      !sessionStorage.getItem("token")
    ) {
      navigate("/forfaits/acheter");
    } else if (
      user &&
      user.motdepasseisactif &&
      !sessionStorage.getItem("token")
    ) {
      console.log("welcome 4");
    }
  }, []);

  return (
    <div className="w-full min-h-screen bg-gray-mtn flex flex-col items-center pt-32">
      <div className="mb-10">
        <img src={LOGO_MTN2} alt="" className="w-32" />
      </div>
      <div className="pb-32">
        <div className="w-[93vw] sm:w-[450px] max-w-[450px] h-fit bg-white shadow-xl rounded-xl border mx-3 p-5">
          <h1 className="text-center text-lg font-bold mx-5 pb-3">
            Réinitialiser votre mot de passe
          </h1>
          {/* <div className="mt-8">
            <div className="mb-2">
              <label htmlFor="" className="text-sm">
                Numéro de téléphone
              </label>
            </div>
            <input
              disabled={loading}
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
              type="tel"
              placeholder="Numéro de téléphone (0574328821)"
              className="input input-bordered w-full bg-gray-mtn"
            />
          </div> */}
          {showCodeOtop ? (
            <div className="mt-4">
              <div className="flex justify-between items-center mb-2">
                <label htmlFor="" className="text-sm">
                  Code reçu par sms
                </label>
                {/* <button
                  className="underline text-right text-sm"
                  onClick={resendOTP}
                >
                  Recevoir le code
                </button> */}
              </div>
              <input
                disabled={loading}
                value={codeOtp}
                onChange={(e) => setCodeOtp(e.target.value)}
                type="number"
                placeholder="0000"
                className="input input-bordered w-full bg-gray-mtn"
              />
            </div>
          ) : null}
          {!showCodeOtop ? (
            <button
              disabled={loading}
              className="bg-jaune-mtn font-bold text-sm w-full h-10 rounded-lg mt-5 flex items-center justify-center"
              onClick={getCodeOPT}
            >
              {!loading ? (
                <>Obtenier un code de réinitialisation</>
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={loading}
                />
              )}
            </button>
          ) : null}
          {showCodeOtop ? (
            <button
              disabled={fetchOTP}
              className="bg-jaune-mtn font-bold text-sm w-full h-10 rounded-lg mt-5 flex items-center justify-center"
              onClick={verificationDuCodeOTP}
            >
              {!fetchOTP ? (
                <>Réinitialiser le mot de passe</>
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={fetchOTP}
                />
              )}
            </button>
          ) : null}
          {errorMessage ? (
            <div className="mt-4">
              <p className="text-red-500 text-center font-bold">
                {errorMessage}
              </p>
            </div>
          ) : null}
          <div className="text-center mt-5">
            <Link to="/password-access">
              <button className="underline">Accéder à la connexion</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
